
//@ts-check
var texts = require("./texts")
var textBuilder = require("./text-builder")
/** Consts to be used by tests */
module.exports = {
  texts, // we declaring it here, so tests that using costs will be able to easly use this module without importing this directly
  textBuilder, // we declaring it here, so tests that using costs will be able to easly use this module without importing this directly

  not_logged_in_tip: "This feature is only available to logged in users.",
  private_tip:"Only users in your organization can access this simulation",
  public_tip:"Simulation is public. For creating private simulation please create a review. Contact us for more details.",
  favorite_tip:"You must be signed in to favorite this simulation",

  EXPLAIN_PASS_WHILE_TRANSACTION_FAILED:'Although the transaction was reverted. It passed the step expectation.',
  EXPLAIN_FAIL_WHILE_TRANSACTION_SUCCESS:"Although the transaction was successful. It is not pass the step expectation.",
  FEATURE_FLAG_REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS:'REVIEW_TOOL_ALLOW_PRIVATE_SIMULATIONS',
  REQUEST_STATES: {
    READY: "READY",
    ONGOING: "ONGOING",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
  },

  getStepNameByType(step_type,isDryRun=false) {
    var step_names = {
      [module.exports.STEP_TYPES.COMPILE_SMART_CONTRACT]: 
      isDryRun ?
      "Deploy a smart contract" : 'Deploy a smart contract',
      
      [module.exports.STEP_TYPES.ENCODE_TRANSACTION]: 
      isDryRun ?
      "Execute a smart contract function" : 'Execute transaction',
      [module.exports.STEP_TYPES.MANUAL_TRANSACTION]: "manual Transaction",
      [module.exports.STEP_TYPES.ETHER_FUND]: "Ether fund",
      [module.exports.STEP_TYPES.CHECk_BALANCE]: "Check ETH balance",
    }
    return step_names[step_type] || step_type
  },

  STEP_TYPES: {
    /**
        Do not change the ENUM without change the strings in the interfaces.ts file
     */
    /**  @type {import('../backend/interfaces').StepTypes.DEPLOY} */
    //@ts-ignore
    DEPLOY: "DEPLOY",

    /**  @type {import('../backend/interfaces').StepTypes.ETHER_FUND} */
    //@ts-ignore
    ETHER_FUND: "ETHER_FUND",

    /**  @type {import('../backend/interfaces').StepTypes.CHECk_BALANCE} */
    //@ts-ignore
    CHECk_BALANCE: "CHECk_BALANCE",

    /**  @type {import('../backend/interfaces').StepTypes.REGEXP} */
    //@ts-ignore
    REGEXP: "REGEXP",

    /** @type {import('../backend/interfaces').StepTypes.MINT_ERC20}*/
    //@ts-ignore
    MINT_ERC20: "MINT_ERC20",

    /** @type {import('../backend/interfaces').StepTypes.DEPLOY_ERC20}*/
    //@ts-ignore
    DEPLOY_ERC20: "DEPLOY_ERC20",

    /** @type {import('../backend/interfaces').StepTypes.EXECUTE_JS_FUNCTION}*/
    //@ts-ignore
    EXECUTE_JS_FUNCTION: "EXECUTE_JS_FUNCTION",

    /** @type {import('../backend/interfaces').StepTypes.MANUAL_STEP}*/
    //@ts-ignore
    MANUAL_TRANSACTION: "MANUAL_TRANSACTION",

    /** @type {import('../backend/interfaces').StepTypes.EXEC_FUNCTION}*/
    //@ts-ignore
    EXEC_FUNCTION: "EXEC_FUNCTION",

    /** @type {import('../backend/interfaces').StepTypes.MATCH_ABI}*/
    //@ts-ignore
    MATCH_ABI: "MATCH_ABI",

    /** @type {import('../backend/interfaces').StepTypes.DOES_NOT_MATCH_ABI}*/
    //@ts-ignore
    DOES_NOT_MATCH_ABI: "DOES_NOT_MATCH_ABI",

    /** @type {import('../backend/interfaces').StepTypes.MATCH_STEPS_RESULTS}*/
    //@ts-ignore
    MATCH_STEPS_RESULTS: "MATCH_STEPS_RESULTS",

    /** @type {import('../backend/interfaces').StepTypes.COMPILE_SMART_CONTRACT}*/
    //@ts-ignore
    COMPILE_SMART_CONTRACT: "COMPILE_SMART_CONTRACT",

    /** @type {import('../backend/interfaces').StepTypes.ENCODE_TRANSACTION}*/
    //@ts-ignore
    ENCODE_TRANSACTION: "ENCODE_TRANSACTION",
  },
  TEST_CATEGORIES: {
    /** @type   {import('../backend/interfaces').categories}*/
    //@ts-ignore
    QUALITY: "Quality",

    /** @type   {import('../backend/interfaces').categories}*/
    //@ts-ignore
    SECURITY: "Security",

    /** @type   {import('../backend/interfaces').categories}*/
    //@ts-ignore
    FUNCTIONALITY: "Functionality",

    /** @type   {import('../backend/interfaces').categories}*/
    //@ts-ignore
    OVERVIEW: "Overview",

    /** @type   {import('../backend/interfaces').categories}*/
    //@ts-ignore
    EFFICIENCY: "Efficiency",

    /** @type   {import('../backend/interfaces').categories}*/
    //@ts-ignore
    TOKEN_EXISTENCE: "Token Existence",
  },
  TEST_SUB_CATEGORIES: {
    /** @type   {import('../backend/interfaces').subCategories}*/
    //@ts-ignore
    ERC20: "ERC-20",

    /** @type   {import('../backend/interfaces').subCategories}*/
    //@ts-ignore
    BURNABLE: "Burnable",

    /** @type   {import('../backend/interfaces').subCategories}*/
    //@ts-ignore
    PAUSABLE: "Pausable",

    /** @type   {import('../backend/interfaces').subCategories}*/
    //@ts-ignore
    MINTABLE: "Mintable",

    /** @type   {import('../backend/interfaces').subCategories}*/
    //@ts-ignore
    CAPPED: "Capped",
  },
  INPUTS: {
    HOLDER: "0x0000000000000000000000000000000000000002",
  },
  RETURN_TYPE: {
    /** @type {import('../backend/interfaces').TestReturnTypes.YES_OR_NO}*/
    //@ts-ignore
    YES_OR_NO: "YES_OR_NO",

    /** @type {import('../backend/interfaces').TestReturnTypes.EXECUTION_OUTPUT}*/
    //@ts-ignore
    EXECUTION_OUTPUT: "EXECUTION_OUTPUT",
  },
  NODES: {
    PUBLIC_NODE: "PUBLIC_NODE",
    LOCAL_NODE: "LOCAL_NODE",
  },
  SUCCESS: "SUCCESS",
  SHORT_ADDRESS: "0xa0001aaaaa",
  REVERTED: "REVERTED",
  OWNER1: "0x0000000000000000000000000000000000000100",
  NON_OWNER1: "0x0000000000000000000000000000000000000002",
  NON_OWNER2: "0x0000000000000000000000000000000000000003",
  NULL_ADDRESS: "0x0000000000000000000000000000000000000000",
  SMART_CONTRACT_ADDRESS1: "0x1000000000000000000000000000000000000000",
  SMART_CONTRACT_ADDRESS2: "0x2000000000000000000000000000000000000000",

  // AST related constants
  nodeTypes: {
    /** @type {"FunctionDefinition"} */
    //@ts-ignore
    FUNCTION_DEFINITION: "FunctionDefinition",
    /** @type {"ContractDefinition"} */
    //@ts-ignore
    CONTRACT_DEFINITION: "ContractDefinition",
    /** @type {"SourceUnitNode"} */
    //@ts-ignore
    SOURCE_UNIT: "SourceUnit",
    /** @type {"PragmaDirectiveNode"} */
    //@ts-ignore
    PRAGMA_DIRECTIVE: "PragmaDirective",
    /** @type {"ExpressionStatement"} */
    //@ts-ignore
    EXPRESSION_STATEMENT: "ExpressionStatement",
    /** @type {"IfStatement"} */
    //@ts-ignore
    IF_STATEMENT: "IfStatement",
    /** @type {"VariableDeclaration"} */
    //@ts-ignore
    VARIABLE_DECLERATION: "VariableDeclaration",
    VARIABLE_DECLERATION_STATEMENT: "VariableDeclarationStatement",
    ELEMENTARY_TYPE: "ElementaryTypeName",
    BLOCK_TYPE: "Block",
    EVENT_DEFINITION: "EventDefinition",
    FUNCTION_CALL: "FunctionCall",
    BINARY_OPERATION: "BinaryOperation",
    INDEX_ACCESS: "IndexAccess",
    IDENTIFIER: "Identifier",
  },
  expressionTypes: {
    ASSIGNMENT: "Assignment",
    MEMBER_ACCESS: "MemberAccess",
  },
  bodyKeys: ["body", "trueBody", "falseBody"],
  risk_rating: {
    likelihood: {
      title: "Factors for Estimating Likelihood",
      description:
        "How likely this particular vulnerability is to be uncovered and exploited by an attacker",
      threat_Agent: {
        title: "Threat Agent Factors",
        description:
          "The first set of factors are related to the threat agent involved. The goal here is to estimate the likelihood of a successful attack by this group of threat agents. Use the worst-case threat agent.",
        skill_level: {
          decription: "How technically skilled is this group of threat agents",
          "No technical skills": 1,
          "some technical skills": 3,
          "advanced computer user": 5,
          "network and programming skills": 6,
          "security penetration skills": 9,
        },
        motive: {
          description:
            "How motivated is this group of threat agents to find and exploit this vulnerability?",
          "Low or no reward": 1,
          "possible reward": 4,
          "high reward": 9,
        },
        opportunity: {
          description:
            "What resources and opportunities are required for this group of threat agents to find and exploit this vulnerability?",
          "Full access or expensive resources required": 0,
          "special access or resources required": 4,
          "some access or resources required": 7,
          "no access or resources required": 9,
        },
        size: {
          description: "How large is this group of threat agents? ",
          Developers: 2,
          "system administrators": 2,
          "intranet users": 4,
          partners: 5,
          "authenticated users": 6,
          "anonymous Internet users": 9,
        },
      },
      "Vulnerability Factors": {
        description:
          "The next set of factors are related to the vulnerability involved. The goal here is to estimate the likelihood of the particular vulnerability involved being discovered and exploited. Assume the threat agent selected above.",
        "Ease of discovery": {
          description:
            "How easy is it for this group of threat agents to discover this vulnerability?",
          "Practically impossible": 1,
          difficult: 3,
          easy: 7,
          "automated tools available": 9,
        },
        "Ease of exploit": {
          description:
            "How easy is it for this group of threat agents to actually exploit this vulnerability?",
          Theoretical: 1,
          difficult: 3,
          easy: 5,
          "automated tools available": 9,
        },
        Awareness: {
          description:
            "How well known is this vulnerability to this group of threat agents?",
          Unknown: 1,
          hidden: 4,
          obvious: 6,
          "public knowledge": 9,
        },
        "Intrusion detection": {
          description: "How likely is an exploit to be detected?",
          "Active detection in application": 1,
          "logged and reviewed": 3,
          "logged without review": 8,
          "not logged": 9,
        },
      },
    },
    impact: {
      title: "Factors for Estimating Impact",
      description: "The impact of a successful attack",
      financial: {
        title: "Financial damage",
        description: "How much financial damage will result from an exploit?",
        "Less than the cost to fix the vulnerability": 1,
        "minor effect on annual profit": 3,
        "significant effect on annual profit": 7,
        bankruptcy: 9,
      },
      reputation: {
        title: "Reputation damage",
        description:
          "Would an exploit result in reputation damage that would harm the business?",
        "Minimal damage": 1,
        "Loss of major accounts": 4,
        "loss of goodwill": 5,
        "brand damage": 9,
      },

      non_compliance: {
        title: "Non-compliance",
        description: "How much exposure does non-compliance introduce?",
        "Minor violation": 2,
        "clear violation": 5,
        "high profile violation": 7,
      },
      loss_of_accountability: {
        title: "Loss of accountability",
        description:
          "Are the threat agents' actions traceable to an individual?",
        "Fully traceable": 1,
        "possibly traceable": 7,
        "completely anonymous": 9,
      },
      loss_of_availability: {
        title: "Loss of availability",
        description: "How much service could be lost and how vital is it?",
        "Minimal secondary services interrupted": 1,
        "minimal primary services interrupted": 5,
        "extensive secondary services interrupted": 5,
        "extensive primary services interrupted": 7,
        "all services completely lost": 9,
      },
      loss_of_integrity: {
        title: "Loss of availability",
        description: "How much data could be corrupted and how damaged is it?",
        "Minimal slightly corrupt data": 1,
        "minimal seriously corrupt data": 3,
        "extensive slightly corrupt data": 5,
        "extensive seriously corrupt data": 7,
        "all data totally corrupt": 9,
      },
    },
  },
  DEFAULT_ADDRESS: "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
  FILE_BROWSER_WIDTH: 303,
  FILE_MANAGER_HEIGHT: 50,
  FILE_EXPLORER_FILENAME_MAX_LENGTH: 40,
  FILE_EXPLORER_MAX_FILES: 200,
  FILE_EXPLORER_FILENAME_LENGTH_DISPLAYED: 26,
  SNIPPET_FILENAME_LENGTH_DISPLAYED: 20,
  key_codes: {
    enter: 13,
    escape: 27,
  },
  NEW_FOLDER_INITIAL_NAME: "",
  TEMP_FOLDER_LOCATION_MARKER: "___TEMP_FOLDER___",
  WARNING_INDICATOR_STRING: ": Warning: ",
  SAMPLES:[
    {
      name:'Sample 1',
      files:[{ path: "main.sol", content: `pragma solidity >=0.8.0;
      contract SampleContract {
      uint storedData;
      function set(uint x) public {
          storedData = x;
      }
      function get() public view returns (uint) {
          return storedData;
      }
    }`}],
    },
    {
      name:'Sample 2',
      files:require('./standard-erc-sample1.js')
    },
    {
      name:'Sample 3',
      files:require('./standard-erc-sample2.js')
    },
  ],
  FILE_EXPLORER_EMPTY_FILES_LIST: [{ path: "main.sol", content: "" }],
  MAX_COMPILATION_ERRORS: 10,
  ERROR_LOCATION_REGEX: /^\S+:\s/,
  ERROR_LOCATION_REGEX_TRAILING_PUNCTUATION_COUNT: 2, // two trailing characters, a colon and then a blank space
  SUBSCRIPTIONS: {
    TESTING_STUDIO: "testing_studio",
    ALL_SCR_TESTS: "all_scr_tests",
    SHOW_SCR_CATEGORIES: "show_scr_categories",
  },
  UI_RESULT_TYPES: {
    PASS: "Pass",
    FAIL: "Fail",
    INFO: "Info",
    NOT_APPLICABLE: "NA",
  },
  MIXPANEL_EVENTS: {
    SCAN_CONTRACT: 'User scans a smart contract',
    EXTRACT_MAINNET_ADDRESS: 'User loads mainnet code to editor',
    REVIEW_CATEGORY: 'Users selects a testing category',
    REVIEW_TEST: 'User expands a closed test result',
  },
  links: {
    randomRiskAndRecommendation: [
      'https://ethereum.stackexchange.com/questions/191/how-can-i-securely-generate-a-random-number-in-my-smart-contract',
      'https://github.com/randao/randao/blob/master/README.md',
    ],
  },
  MAX_ITERATIONS: 100,
  STUDIO_DASHBOARD_COLUMN_NAMES: {
    name: "Name", 
    description: "Description", 
    created_by: "Created By", 
    creation_date: "Creation Date", 
    action: "Action"
  },
  SAMPLE_AVATAR_URL: "https://cdn.auth0.com/avatars/",
  SAMPLE_AVATAR_FILE_EXTENSION: "png",
  BLANK_FIELD_INDICATOR: "-",
  MUI_COLORS_LIST: [
    "red", 
    "pink", 
    "purple", 
    "deepPurple", 
    "indigo", 
    "blue", 
    "lightBlue", 
    "cyan", 
    "teal", 
    "green", 
    "lightGreen", 
    "lime", 
    "yellow", 
    "amber", 
    "orange", 
    "deepOrange", 
    "brown", 
    "grey", 
    "blueGrey",  
  ],
  SCR_APP_URLS: {
    automated: "/automated",
    ai:'/ai',
    getContractABI: "/get-contract-abi",
    verifyContractByteCode: "/verify-contract-byte-code",
    aiReviewAgent: "/ai-review-agent",
    studio: "/stories",
    library: "/library",
    simulation: "/simulation",
    simplifier: "/simplifier",
    myReview: "/my-reviews",
    ciReview: "/ci-reviews",
    ercBalanceCheck: "/erc-balance-check",
    engagementManager: "/engagement-manager",
    organizationManager: "/organization-manager",
    analytics: "/analytics",
    scAnalyzer: "/sc-analyzer",
    askQuestion: "/ask-question",
    aiReviewAgent: "/ai-review-agent",
  },
  SANDBOX_ENVIRONMENTS: {
    BLANK_STATE: { 
      key: "BLANK_STATE",
      label: "New Sandbox",
    },
    MAINNET: { 
      key: "MAINNET",
      label: "Mainnet Simulation",
    },
    LIVE: { 
      key: "LIVE",
      label: "Live (MetaMask)",
    },
  },
}
